// extracted by mini-css-extract-plugin
export var aiStarIcon = "_l1-2";
export var container = "_l1-4";
export var dismissButton = "_l1-3";
export var hasPaddingBottom = "_l1-6";
export var last = "_l1-e";
export var scrollbarThumb = "_l1-c";
export var scrollbarTrack = "_l1-b";
export var selected = "_l1-9";
export var spin = "_l1-1";
export var spinning = "_l1-0";
export var suggestionItem = "_l1-d";
export var suggestionsPanel = "_l1-5";
export var tonePill = "_l1-8";
export var tonesContainer = "_l1-7";
export var unselected = "_l1-a";